
import { css } from 'lit';
export default css`
:host{
  --pc-hero-left-background-color:var(--neutral-snow);
  --pc-hero-right-background-color:var(--primary-white);
  --heading-font-family:var(--ff-body);
  --pc-hero-background-color:linear-gradient(
    to right,
    var(--pc-hero-left-background-color) 0%,
    var(--pc-hero-left-background-color) 50%,
    var(--pc-hero-right-background-color) 50%,
    var(--pc-hero-right-background-color) 100%
  );

  --pc-hero-background-color-mobile:var(--pc-hero-left-background-color);

  display:block;
  position:relative;
  -webkit-print-color-adjust:exact;
  print-color-adjust:exact;
}

.hero{
  border-radius:0px 0px 50px 0px;
  background-color:var(--pc-hero-background-color-mobile);
  overflow:hidden;
  position:relative;
  -webkit-print-color-adjust:exact;
  print-color-adjust:exact;
}

pc-container{
  background-color:var(--pc-hero-left-background-color);
  padding:var(--spacing-8) 0 var(--spacing-6) 0;
  overflow:hidden;
  -webkit-print-color-adjust:exact;
  print-color-adjust:exact;
}

.left-side{
  position:absolute;
  visibility:hidden;
  opacity:0;
  content-visibility:visible;
}

.container{
  padding-top:var(--spacing-6);
}

.right-side{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-4);
}

@media print{

.right-side{
    gap:var(--spacing-0)
}
  }

::slotted([slot='contact']){
  display:flex;
  flex-direction:column;
  gap:var(--spacing-4);
}

@media print, (min-width: 992px){
  .hero{
    border-radius:inherit;
    background:var(--pc-hero-background-color);
    -webkit-print-color-adjust:exact;
    print-color-adjust:exact;
  }

  pc-container{
    border-radius:0px 0px 64px 0px;
    padding:var(--spacing-8) 0 var(--spacing-16);
    position:relative;
    -webkit-print-color-adjust:exact;
    print-color-adjust:exact;
  }

  .container{
    display:grid;
    grid-template-columns:calc((3 / 12) * 100%) calc((9 / 12) * 100%);
    gap:calc((0.5 / 12) * 100%);
    align-items:start;
    overflow:hidden;
    padding-top:var(--spacing-12);
  }

  @media (min-width: 1280px){
    .container{
      grid-template-columns:calc((3 / 12) * 100%) calc((8 / 12) * 100%);
      gap:calc((1 / 12) * 100%);
    }
  }

  .left-side{
    position:static;
    visibility:visible;
    opacity:1;
    display:block;
  }

  .right-side{
    display:flex;
    flex-direction:column;
    box-sizing:border-box;
    margin-right:1rem;
    margin-left:1rem;
    padding-right:var(--spacing-20);
  }

  ::slotted([slot='contact']){
    gap:var(--spacing-6);
  }

  .without-image pc-container::before{
    content:none;
  }

  .without-image .left-side{
    display:none;
  }

  .without-image .container{
    grid-template-columns:calc((8 / 12) * 100%);
  }
}

@media (min-width: 1536px){
  pc-container::before{
    bottom:-30px;
  }
}

@media print{

::slotted([slot='contact']){
    gap:var(--spacing-0)
}
  }
`;